import {Component, Input, OnInit} from '@angular/core';
import {MercadoInternoMercadoriasService} from './mercado-interno-mercadorias.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {MercadoInternoClassificacaoService} from "./mercado-interno-classificacao.service";

declare let $, swal: any;

@Component({
  selector: 'app-mercado-interno-tabela-indices-classificacao',
  templateUrl: './mercado-interno-tabela-indices-classificacao.component.html'
})
export class MercadoInternoTabelaIndicesClassificacaoComponent implements OnInit {

  carregandoTabelaIndicesClassificacao: boolean = true;
  listIndicesClassificacao = [];

  @Input()
  id_mercadoria = null;

  @Input()
  id_defeito = null;

  constructor(
    private mercadoriasService: MercadoInternoMercadoriasService,
    public func: Funcoes,
    public global: Global,
    private mercadoriasClassificacaoService: MercadoInternoClassificacaoService
  ) {

  }

  ngOnInit() {
    if (this.id_mercadoria && this.id_defeito) {
      this.mercadoriasClassificacaoService.get(null, {"id_mercadoria": this.id_mercadoria, "id_defeito": this.id_defeito}, null, {"ordem": "A"})
        .subscribe(data => {
            this.listIndicesClassificacao = data['Payload'];
            this.carregandoTabelaIndicesClassificacao = false;
          },
          error => {
            this.func.showErro(error.json());
            this.carregandoTabelaIndicesClassificacao = false;
          });
    } else {
      this.carregandoTabelaIndicesClassificacao = false;
    }
  }

  deleteIndiceClassificacao(indice) {
    let classificacoes = this.listIndicesClassificacao;
    let mercadoriasClassificacaoService = this.mercadoriasClassificacaoService;
    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarIndiceClassificacao')+indice.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        let index = classificacoes.indexOf(indice);
        classificacoes.splice(index, 1);

        mercadoriasClassificacaoService.apagar(indice.id)
          .subscribe(res => {
              self.listIndicesClassificacao = classificacoes;
            },
            err => {
              classificacoes.splice(index, 0, indice);
              self.listIndicesClassificacao = classificacoes;
              self.func.showErro(err.json());
            });
      });
  }

  ordenouIndicesClassificacao(e) {
    for (let i in this.listIndicesClassificacao) {
      this.listIndicesClassificacao[i].ordem = parseInt(i) + 1;
    }
    this.mercadoriasClassificacaoService.ordenaIndices(this.listIndicesClassificacao)
      .subscribe(json => { });
  }

}



// WEBPACK FOOTER //
// ./src/app/mercado-interno-mercadorias/mercado-interno-tabela-indices-classificacao.component.ts